import { useEffect, useState } from 'react';
import { useAuth } from '../../shared/hooks/useAuth';
import api from '../../shared/services/api/api';
import Report from '../components/Report';

type ReportResult = Report[];

const ReportPage = () => {
  const auth = useAuth();
  const [results, setResults] = useState<ReportResult | null>(null);
  const username = auth?.user?.username ?? '';
  const patientId = auth?.user?.session?.pk_id_pt ?? '';

  useEffect(() => {
    const getData = async () => {
      const response = await api.report({ username, patientId });
      if (response.status !== 200) {
        console.error('Error', response.statusText);
      }
      if (response.error === 0) {
        setResults(response.data);
      }
    };
    getData();
  }, [patientId, username]);

  return (
    <>
      {results?.map((res, i) => <Report key={`${res?.codice}_${i}`} report={res} patientId={patientId} />)}
      {/* <TableResults pkIdPt={pkIdPt} username={username} /> */}
    </>
  );
};

export default ReportPage;
